import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { theme } from '../../../../theme'

import OTPInputBoxes from '../OTPInputBoxes/OTPInputBoxes'

import * as Styles from './styles'

interface Props {
   onChange: (code: string) => void
   otpValue: string
   isError?: boolean
   label?: string
   errorMessage?: string
   shouldAutoFocus: boolean
   isDisabled?: boolean
   inputClassName?: string
   inputFocusClassName?: string
   errorClassName?: string
   apiStatus?: number
   labelStyles?: string
   otpContainerStyles?: string
   containerStyle?: string
   numInputs?: number
   onBlur?: (event: React.SyntheticEvent) => void

   isFocus?: boolean
   hideSeparator?: boolean
}

const SixBoxesOtpInputField = (props: Props): React.ReactElement => {
   const {
      onChange,
      otpValue,
      isError,
      label,
      shouldAutoFocus,
      isDisabled,
      inputClassName,
      inputFocusClassName,
      errorClassName,
      apiStatus,
      containerStyle,
      onBlur,
      isFocus,
      hideSeparator,
      numInputs
   } = props

   const { otpInputs: otpInputTheme, sixBoxesInputTheme } = theme

   return (
      <div className={cn(Styles.otpInputContainerStyles)}>
         {label ? (
            <span
               className={cn(
                  Styles.labelContainerStyles,
                  Styles.otpFieldLabelStyles,
                  sixBoxesInputTheme.labelTextColor
               )}
            >
               {label}
            </span>
         ) : null}
         <OTPInputBoxes
            value={otpValue}
            onChange={onChange}
            numInputs={numInputs ?? 6}
            hasErrored={isError}
            inputStyle={
               inputClassName ??
               cn(
                  Styles.otp_InputContainer_Styles,
                  otpInputTheme.otpInputBGColor,
                  otpInputTheme.otpInputDisabledBorderColor,
                  otpInputTheme.otpInputTextColor
               )
            }
            focusStyle={
               inputFocusClassName ??
               cn(
                  Styles.otpInputFocusStyleStyles,
                  otpInputTheme.otpInputFocusBGColor,
                  otpInputTheme.otpInputFocusBorderColor
               )
            }
            errorStyle={
               errorClassName ??
               cn(
                  Styles.otpInputErrorStyleStyles,
                  otpInputTheme.otpInputErrorBorderColor,
                  otpInputTheme.otpErrorInputTextColor
               )
            }
            shouldAutoFocus={shouldAutoFocus}
            isDisabled={isDisabled}
            apiStatus={apiStatus}
            containerStyle={containerStyle}
            onBlur={onBlur}
            isFocus={isFocus}
            placeholder={'000000'}
            hideSeparator={hideSeparator}
         />
         {props.errorMessage ? (
            <span
               className={cn(
                  Styles.errorMessageStyles,
                  otpInputTheme.errorMessageTextColor
               )}
            >
               {props.errorMessage}
            </span>
         ) : null}
      </div>
   )
}

export default observer(SixBoxesOtpInputField)
